export const historyYears = {
  '1403': 44,
  '1402': 36,
  '1398': 26,
  '1395': 8,
  '1393': 2,
};

type textType = {
  title: string;
  subTitle?: string[];
  subtitle?: string;
  subtitle1?: string;


};
export type historyType = {
  note: textType & {
    author: string;
  };
  description: textType;
  image: string;
  month: string;
  day: string;
};
